



















import mixins from 'vue-typed-mixins';
import EmailForm from '@/components/email/EmailForm.vue';
import EmailUtils, { AutomatedEmail } from '@/utils/EmailUtils';
export default mixins().extend({
  components: {
    EmailForm,
  },
  computed: {
    id(): number {
      return parseInt(this.$route.params.emailId);
    },
  },
  data(): {
    email: Partial<AutomatedEmail>;
  } {
    return {
      email: {
        key: undefined,
        name: undefined,
        type: undefined,
        system: false,
        subject: this.$languageobj(undefined, undefined, {
          additional_locales: ['multi'],
        }),
        body: this.$languageobj(undefined, undefined, {
          additional_locales: ['multi'],
        }),
        defaultsignature: undefined,
        signature: undefined,
      },
    };
  },
  methods: {
    async submit() {
      try {
        this.$alert.hide('submit');
        await EmailUtils.api.add(this.email as AutomatedEmail);
        await this.$router.push({ name: 'email-list' });
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.email.name],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
  },
});
